import { t } from '@avalara/bat-apps-shared/i18n';

import type { PriceTableRow } from '../../../../../types/product-detail';

type Props = {
  rows: Array<PriceTableRow>;
};

// Volume-pricing table shown in the Order Summary above the quantity row (e.g. Managed Returns'
// "Returns per year" / "Price per return" table) — same data/copy as the PDP's price table
// (product-catalog/product-detail/pricing-tiers.tsx) rendered in the order-review context instead
// of inside an SCardAction tier card.
const OrderReviewPriceTable = ({ rows }: Props) => (
  <table className='order-review-price-table' data-ref='buy.order-review.summary.price-table'>
    <thead>
      <tr>
        <th>{t('client.product-detail.price-table.range-header')}</th>
        <th>{t('client.product-detail.price-table.price-header')}</th>
      </tr>
    </thead>
    <tbody>
      {rows.map((row) => (
        <tr key={row.range}>
          <td>{row.range}</td>
          <td>
            {row.originalPrice && (
              <>
                <span className='order-review-price-table-original-price'>{row.originalPrice}</span> &rarr;{' '}
              </>
            )}
            {row.price}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default OrderReviewPriceTable;
